export default class DomCreate {
    static create(tag, classes= [], attributes = {}) {
        const element = document.createElement(tag);
        classes.forEach(className => element.classList.add(className));
        Object.keys(attributes).forEach(attributeName => element.setAttribute(attributeName, attributes[attributeName]));
        return element;
    }
}